module.exports = __webpack_public_path__ + "img/VL_09_01.f0818467.png";